exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-pos-2[data-v-a41676a2]{top:40px;left:35px}.login-pos-2[data-v-a41676a2]{top:50px;right:35px}.taller[data-v-a41676a2]{height:110px}", ""]);

// exports
